var map = {
	"./backstage/master/sampleInformation.js": "395b",
	"./backstage/master/sampleMetadata.js": "31bd",
	"./backstage/samplemanage/stockSampleLocation.js": "1c2a",
	"./digital/baseUser/index.js": "9e98",
	"./digital/common/attribute.js": "f5db",
	"./digital/common/dict.js": "e5f4",
	"./digital/common/sysdownload.js": "1bbaf",
	"./digital/components/projectmap.js": "6210",
	"./digital/custManagement/brand.js": "a077",
	"./digital/custManagement/costSector.js": "96e6",
	"./digital/custManagement/custAudit.js": "3309",
	"./digital/custManagement/custBizTeamSet.js": "6c07",
	"./digital/custManagement/custInfo.js": "b21a",
	"./digital/custManagement/customerQuotation.js": "2b12",
	"./digital/custManagement/info.js": "123f",
	"./digital/custManagement/myCust.js": "9b7c",
	"./digital/custManagement/proofingRecord.js": "b6e0",
	"./digital/custManagement/riskCheck.js": "a008",
	"./digital/custManagement/selectionQuotation.js": "d758",
	"./digital/custManagement/selectionTracking.js": "3b37",
	"./digital/custManagement/sendSample.js": "44d7",
	"./digital/dataAnalysis/report.js": "071e",
	"./digital/designElements/category.js": "aed7",
	"./digital/designElements/dictionary.js": "c6da",
	"./digital/designElements/info.js": "92b9",
	"./digital/designElements/inputTemplate.js": "d453",
	"./digital/designElements/resFabric.js": "4f0b",
	"./digital/designElements/sampleInfo.js": "4357",
	"./digital/designElements/tag.js": "f572",
	"./digital/expo/choiceSample.js": "c4eb",
	"./digital/expo/info.js": "4319f",
	"./digital/expo/meetingSet.js": "5d2b",
	"./digital/expo/tskInfo.js": "9484",
	"./digital/export/ppt/template.js": "e4d1",
	"./digital/master/fabric.js": "5163",
	"./digital/master/fabricAttributes.js": "ba1c",
	"./digital/master/fabricCard.js": "a5c2",
	"./digital/master/fabricCategory.js": "8658",
	"./digital/master/fabricExpense.js": "00c0",
	"./digital/master/fabricImages.js": "96f5",
	"./digital/master/fabricRequest.js": "5630",
	"./digital/master/fabricStock.js": "b725",
	"./digital/master/fabricStockIn.js": "c7f7",
	"./digital/master/fabricStockInColor.js": "1a10",
	"./digital/master/fabricStockOut.js": "fbdf",
	"./digital/master/fabricStockOutDetail.js": "1fb3",
	"./digital/master/greyfabric.js": "a578",
	"./digital/master/stockChangeLog.js": "db47",
	"./digital/personal/dashBoard.js": "1c16",
	"./digital/personal/myBizContactForm.js": "3924",
	"./digital/personal/myLoanRequest.js": "feff",
	"./digital/personal/myPaymentRequest.js": "e71f",
	"./digital/personal/myProjects.js": "6f5d",
	"./digital/personal/myProofing.js": "1b84",
	"./digital/personal/myQuotation.js": "ac5f",
	"./digital/personal/myRecommend.js": "41c5",
	"./digital/personal/myReimbursement.js": "b31f",
	"./digital/personal/myResearchFabric.js": "1a13",
	"./digital/personal/myTravel.js": "7b05",
	"./digital/personal/myTravelReimbursement.js": "865b",
	"./digital/personal/shopProductCart.js": "cfab",
	"./digital/personal/shopProductCollect.js": "171f",
	"./digital/personal/taskCenter.js": "a1c4e",
	"./digital/personal/userMaterialAbnormal.js": "3d5b",
	"./digital/projectManager/category.js": "8780",
	"./digital/projectManager/dictionary.js": "2dc2",
	"./digital/projectManager/feedback.js": "8e6c",
	"./digital/projectManager/info.js": "0ce4",
	"./digital/projectManager/infoCustomerRecommend.js": "7a69",
	"./digital/projectManager/infoDoc.js": "4f6b",
	"./digital/projectManager/infoMaterial.js": "58d2",
	"./digital/projectManager/infoParticipant.js": "343a",
	"./digital/projectManager/infoProduct.js": "f485",
	"./digital/projectManager/infoQuotation.js": "34c0",
	"./digital/projectManager/infoSample.js": "c3ae",
	"./digital/projectManager/infoSchedule.js": "767a",
	"./digital/projectManager/inputTemplate.js": "120c",
	"./digital/projectManager/tag.js": "933b",
	"./digital/research/dictionary.js": "704f",
	"./digital/research/dictionaryType.js": "5622",
	"./digital/research/fabric.js": "5f40",
	"./digital/research/info.js": "a3bd",
	"./digital/research/infoImage.js": "e1d4",
	"./digital/research/inputTemplate.js": "2f35",
	"./digital/research/tag.js": "8b1a",
	"./digital/resourceManagement/resFabric.js": "5876",
	"./digital/resourceManagement/researchInfo.js": "bbc7",
	"./digital/resourceManagement/syscustomerexporttemplate.js": "1032",
	"./digital/scm/appraisalBill.js": "68d9",
	"./digital/scm/appraisalGroup.js": "1cfaa",
	"./digital/scm/bank.js": "0ee5",
	"./digital/scm/category.js": "bc25",
	"./digital/scm/dictionary.js": "557e",
	"./digital/scm/info.js": "8f04",
	"./digital/scm/infoAppraisal.js": "fe4e",
	"./digital/scm/infoContacts.js": "1083",
	"./digital/scm/infoDoc.js": "62e45",
	"./digital/scm/infoImages.js": "5077",
	"./digital/scm/infoScore.js": "4295",
	"./digital/scm/infoVisit.js": "a7dd",
	"./digital/scm/infoVisitScore.js": "bb54",
	"./digital/scm/inputTemplate.js": "72b4",
	"./digital/scm/openapi.js": "b1e6",
	"./digital/scm/ratingItems.js": "6d6e",
	"./digital/scm/tag.js": "5b73",
	"./digital/scm/userContacts.js": "d1df",
	"./digital/supplyChainResources/scmInfo.js": "efb9",
	"./global.js": "ad69",
	"./oss.js": "b85a",
	"./sys.download.js": "47a5",
	"./sys.export.js": "ed33",
	"./sys.locales.js": "39e6",
	"./sys.menu.js": "2e32",
	"./sys.upload.js": "5ec6",
	"./sys.user.js": "c413",
	"./system/merchantUserSet.js": "8d39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a08a";